import { NgModule } from '@angular/core';
import { AnaBizTopService } from './ana-biz-top.service';

@NgModule({
  providers: [AnaBizTopService],
})
export class AnaBizTopServiceModule {}
